module.exports = __webpack_public_path__ + "static/media/thought.117596d6.jpg";